<template>
    <section class="date-picker-container">
        <v-menu ref="menu"
                :close-on-content-click="false"
                v-model="menu"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                max-width="290px"
                min-width="290px"
                :disabled="disabled"
        >
            <v-text-field slot="activator"
                          :value="text"
                          :label="label"
                          :hint="hint"
                          persistent-hint
                          :name="label"
                          readonly
                          :error-messages="errors.collect(label)"
                          data-vv-validate-on="input"
                          :data-vv-name="label"
                          append-icon="arrow_drop_down"
                          :disabled="disabled"
                          ref="text"
            ></v-text-field>
            <i-tree has-search
                    :get-child-url="getChildUrl"
                    :get-root-url="getRootUrl"
                    :item-text="itemText"
                    :item-key="itemKey" :active.sync="active"></i-tree>


        </v-menu>
    </section>
</template>

<script>
    import ITree from "./Tree";
    export default {
        name: 'i-tree-picker',
        components: {ITree},
        inheritAttrs: false,
        data() {
            return {
                menu: false,
                date: this.value,
                text:"",
                active:[]
            }
        },
        props: {
            hint: {
                type: String,
                default: null
            },
            label: {
                type: String,
                default: 'Date'
            },
            value: {
                type: String|Number,
                default: ""
            },
            textValue:{
                type: String,
                default: ""
            },
            readonly:{
                type:Boolean,
                default:false
            },
            disabled: {
                type: Boolean,
                default: false
            },
            hasSearch: {
                type: Boolean,
                default: false
            },
            getRootUrl: {
                type: String,
                default: null
            },
            getChildUrl: {
                type: String,
                default: null
            },
            itemKey: {
                type: String,
                default: null
            },
            itemText: {
                type: String,
                default: null
            }
        },

        computed:{
        },
        watch: {
            textValue:function(txt){
                this.text = txt;
            },
            active:function(data){
                if(data.length >0) {
                    this.text = data[0][this.itemText];
                    this.$emit("input", data[0][this.itemKey]);
                } else {
                    this.$emit("input", null);
                }
                this.menu = false;
            }
        },
        methods: {
            focus:function(){
                this.$refs.text.focus();
            },

            save(data) {
            }
        }
    }
</script>